import { Injectable } from '@angular/core'
import {
  GlobalMessageService,
  GlobalMessageType,
  HttpResponseStatus,
  NotFoundHandler,
  RoutingService
} from '@spartacus/core'

@Injectable({
  providedIn: 'root'
})
export class EbNotFoundHandler extends NotFoundHandler {
  constructor(
    protected routingService: RoutingService,
    protected globalMessageService: GlobalMessageService
  ) {
    super(globalMessageService)
  }

  responseStatus = HttpResponseStatus.NOT_FOUND

  handleError() {
    this.routingService.go({ cxRoute: 'home' })
    this.globalMessageService.add(
      {
        key: 'httpHandlers.notFound'
      },
      GlobalMessageType.MSG_TYPE_ERROR
    )
  }
}
